/**
 * Home page widgets, by tool id. Each module exports `widgets`: widget id → component.
 * Widget metadata (title, size, default) lives in the tool's manifest.
 * Loaded lazily, so widgets only cost bandwidth when they are on someone's home page.
 */
import type { ComponentType } from 'react';
import type { WidgetProps } from '../src/lib/toolkit';

export type WidgetModule = { widgets: Record<string, ComponentType<WidgetProps>> };

export const TOOL_WIDGETS: Record<string, () => Promise<WidgetModule>> = {
  'recommended-assets': () => import('./recommended-assets/widgets'),
  'blueprint-tracker': () => import('./blueprint-tracker/widgets'),
  orbat: () => import('./orbat/widgets'),
  'tsc-requests': () => import('./tsc-requests/widgets'),
  'org-assets': () => import('./org-assets/widgets'),
  calendar: () => import('./calendar/widgets'),
  events: () => import('./events/widgets'),
  'combined-arms': () => import('./combined-arms/widgets'),
  'management-requests': () => import('./management-requests/widgets'),
  analytics: () => import('./analytics/widgets'),
  'my-academy': () => import('./my-academy/widgets'),
  'academy-management': () => import('./academy-management/widgets'),
};
